module.exports = __webpack_public_path__ + "img/pinkSapphire.217ee8b.webp";